<div class="quickpanel">
  <mat-toolbar class="toolbar">
    <span class="toolbar-name">Messagerie</span>
    <span class="toolbar-spacer"></span>

    <button mat-button (click)="closeQuickPanel.emit(false)">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <app-chat-dashboard [closeChat]="closeQuickPanel"></app-chat-dashboard>
</div>
